/**
 * Quiz Parfum — Passion Parfum
 * Interactive perfume recommendation quiz with weighted scoring engine.
 * Vanilla JS, no dependencies.
 */
(function () {
  'use strict';

  /* ============================================
     I18N — TRANSLATIONS
     ============================================ */
  const LOCALE = document.getElementById('quiz-parfum')?.dataset.locale || 'fr';
  const IS_EN = LOCALE.startsWith('en');

  function t(key, replacements) {
    const str = (I18N[LOCALE] && I18N[LOCALE][key]) || (I18N.en && I18N.en[key]) || key;
    if (!replacements) return str;
    return str.replace(/\{(\w+)\}/g, (_, k) => replacements[k] ?? _);
  }

  const I18N = {
    fr: {
      // Badges
      badge_perfect: 'Parfait pour vous',
      badge_good: 'Bonne correspondance',
      badge_discover: 'À découvrir',
      // Results
      results_count: '{count} parfum{plural} correspondent à votre profil',
      results_count_1: '1 parfum correspond à votre profil',
      // Product card
      add_to_cart: 'Ajouter au panier',
      sold_out: 'Épuisé',
      adding: 'Ajout...',
      added: 'Ajouté ✓',
      error: 'Erreur',
      // Diagnostic
      diag_loading: 'Profil en cours...',
      btn_sending: 'Envoi en cours...',
      btn_send_retry: 'Erreur, réessayer',
      // Step counter
      step_count: 'Question {current} / {total}',
      // Dimension labels
      dim_genre: 'Genre',
      dim_famille: 'Famille',
      dim_notes: 'Notes',
      dim_occasion: 'Occasion',
      dim_intensite: 'Intensité',
      dim_saison: 'Saison',
      dim_style: 'Style',
      dim_experience: 'Expérience',
      // Value labels
      val_homme: 'Homme', val_femme: 'Femme', val_mixte: 'Mixte',
      val_boise: 'Boisé', val_floral: 'Floral', val_oriental: 'Oriental',
      val_frais: 'Frais', val_epice: 'Épicé', val_cuir: 'Cuir',
      val_vanille: 'Vanille', val_musc: 'Musc', val_rose: 'Rose', val_oud: 'Oud',
      val_bergamote: 'Bergamote', val_patchouli: 'Patchouli', val_jasmin: 'Jasmin',
      val_ambre: 'Ambre', val_cedre: 'Cèdre', val_iris: 'Iris',
      val_quotidien: 'Quotidien', val_soiree: 'Soirée', val_bureau: 'Bureau',
      'val_rendez-vous': 'Rendez-vous',
      val_legere: 'Légère', val_moderee: 'Modérée', val_intense: 'Intense',
      val_printemps: 'Printemps', val_ete: 'Été', val_automne: 'Automne', val_hiver: 'Hiver',
      val_classique: 'Classique', val_aventurier: 'Aventurier',
      val_romantique: 'Romantique', val_moderne: 'Moderne',
      val_debutant: 'Débutant', val_connaisseur: 'Connaisseur', val_expert: 'Expert',
      // Email body
      email_greeting: 'Cher(e) client(e)',
      email_title: 'Votre Diagnostic Olfactif',
      email_brand: 'Passion Parfum',
      email_top3: 'Vos Top 3 Recommandations',
      email_relevance: 'Pertinence',
      email_cta: 'Voir tous mes résultats',
      email_footer: '© Passion Parfum · Parfums de Niche Exclusifs',
      // Modal & Favorites
      modal_relevance: 'Pertinence',
      btn_view_detail: 'Voir la fiche complète',
      fav_title: 'Ma sélection',
      fav_clear: 'Tout effacer',
      fav_save: 'Enregistrer',
      fav_saved: 'Enregistré',
      sample_btn: 'Échantillon',
      sample_adding: 'Ajout...',
      sample_added: 'Ajouté ✓',
      sample_unavailable: 'Indisponible',
      sample_price: 'Échantillon · {price}',
    },
    en: {
      badge_perfect: 'Perfect for you',
      badge_good: 'Great match',
      badge_discover: 'Worth exploring',
      results_count: '{count} fragrance{plural} match your profile',
      results_count_1: '1 fragrance matches your profile',
      add_to_cart: 'Add to cart',
      sold_out: 'Sold out',
      adding: 'Adding...',
      added: 'Added ✓',
      error: 'Error',
      diag_loading: 'Loading profile...',
      btn_sending: 'Sending...',
      btn_send_retry: 'Error, retry',
      step_count: 'Question {current} / {total}',
      dim_genre: 'Gender',
      dim_famille: 'Family',
      dim_notes: 'Notes',
      dim_occasion: 'Occasion',
      dim_intensite: 'Intensity',
      dim_saison: 'Season',
      dim_style: 'Style',
      dim_experience: 'Experience',
      val_homme: 'Men', val_femme: 'Women', val_mixte: 'Unisex',
      val_boise: 'Woody', val_floral: 'Floral', val_oriental: 'Oriental',
      val_frais: 'Fresh', val_epice: 'Spicy', val_cuir: 'Leather',
      val_vanille: 'Vanilla', val_musc: 'Musk', val_rose: 'Rose', val_oud: 'Oud',
      val_bergamote: 'Bergamot', val_patchouli: 'Patchouli', val_jasmin: 'Jasmine',
      val_ambre: 'Amber', val_cedre: 'Cedar', val_iris: 'Iris',
      val_quotidien: 'Everyday', val_soiree: 'Evening', val_bureau: 'Office',
      'val_rendez-vous': 'Date night',
      val_legere: 'Light', val_moderee: 'Moderate', val_intense: 'Intense',
      val_printemps: 'Spring', val_ete: 'Summer', val_automne: 'Autumn', val_hiver: 'Winter',
      val_classique: 'Classic', val_aventurier: 'Adventurous',
      val_romantique: 'Romantic', val_moderne: 'Modern',
      val_debutant: 'Beginner', val_connaisseur: 'Connoisseur', val_expert: 'Expert',
      email_greeting: 'Dear customer',
      email_title: 'Your Fragrance Profile',
      email_brand: 'Passion Parfum',
      email_top3: 'Your Top 3 Recommendations',
      email_relevance: 'Relevance',
      email_cta: 'See all my results',
      email_footer: '© Passion Parfum · Exclusive Niche Fragrances',
      modal_relevance: 'Match',
      btn_view_detail: 'View full details',
      fav_title: 'My selection',
      fav_clear: 'Clear all',
      fav_save: 'Save',
      fav_saved: 'Saved',
      sample_btn: 'Sample',
      sample_adding: 'Adding...',
      sample_added: 'Added ✓',
      sample_unavailable: 'Unavailable',
      sample_price: 'Sample · {price}',
    },
  };

  /** Get translated value label */
  function tVal(value) {
    return t('val_' + value) || value;
  }

  /** Get translated dimension label */
  function tDim(key) {
    return t('dim_' + key) || key;
  }

  /* ============================================
     CONFIGURATION
     ============================================ */

  /** Tag normalization map: maps common existing tag formats to canonical quiz:dimension:value */
  const TAG_NORMALIZE = {
    // Genre
    'homme': 'quiz:genre:homme',
    'femme': 'quiz:genre:femme',
    'mixte': 'quiz:genre:mixte',
    'unisexe': 'quiz:genre:mixte',
    'pour homme': 'quiz:genre:homme',
    'pour femme': 'quiz:genre:femme',
    // Famille
    'boise': 'quiz:famille:boise',
    'boisé': 'quiz:famille:boise',
    'floral': 'quiz:famille:floral',
    'fleuri': 'quiz:famille:floral',
    'oriental': 'quiz:famille:oriental',
    'orientale': 'quiz:famille:oriental',
    'frais': 'quiz:famille:frais',
    'fraiche': 'quiz:famille:frais',
    'epice': 'quiz:famille:epice',
    'épicé': 'quiz:famille:epice',
    'cuir': 'quiz:famille:cuir',
    'fruite': 'quiz:famille:frais',
    'fruité': 'quiz:famille:frais',
    'gourmand': 'quiz:famille:oriental',
    'citrus': 'quiz:notes:bergamote',
    'musk': 'quiz:notes:musc',
    'sucré': 'quiz:notes:vanille',
    'clean': 'quiz:famille:frais',
    // Notes
    'vanille': 'quiz:notes:vanille',
    'musc': 'quiz:notes:musc',
    'rose': 'quiz:notes:rose',
    'oud': 'quiz:notes:oud',
    'bergamote': 'quiz:notes:bergamote',
    'patchouli': 'quiz:notes:patchouli',
    'jasmin': 'quiz:notes:jasmin',
    'ambre': 'quiz:notes:ambre',
    'cedre': 'quiz:notes:cedre',
    'cèdre': 'quiz:notes:cedre',
    'iris': 'quiz:notes:iris',
    // Occasion
    'quotidien': 'quiz:occasion:quotidien',
    'soiree': 'quiz:occasion:soiree',
    'soirée': 'quiz:occasion:soiree',
    'bureau': 'quiz:occasion:bureau',
    'rendez-vous': 'quiz:occasion:rendez-vous',
    // Intensite
    'legere': 'quiz:intensite:legere',
    'légère': 'quiz:intensite:legere',
    'moderee': 'quiz:intensite:moderee',
    'modérée': 'quiz:intensite:moderee',
    'intense': 'quiz:intensite:intense',
    // Saison
    'printemps': 'quiz:saison:printemps',
    'ete': 'quiz:saison:ete',
    'été': 'quiz:saison:ete',
    'automne': 'quiz:saison:automne',
    'hiver': 'quiz:saison:hiver',
    // Style
    'classique': 'quiz:style:classique',
    'aventurier': 'quiz:style:aventurier',
    'romantique': 'quiz:style:romantique',
    'moderne': 'quiz:style:moderne',
    // Experience
    'debutant': 'quiz:experience:debutant',
    'débutant': 'quiz:experience:debutant',
    'connaisseur': 'quiz:experience:connaisseur',
    'expert': 'quiz:experience:expert',
  };

  /** Ordered dimensions for partial credit scoring */
  const ORDERED_DIMENSIONS = {
    intensite: ['legere', 'moderee', 'intense'],
    experience: ['debutant', 'connaisseur', 'expert'],
  };

  const ADJACENT_CREDIT = 0.4;
  const STORAGE_KEY = 'quiz_parfum_answers';

  /** Patterns to identify sample variants (matched against variant title, lowercased) */
  const SAMPLE_PATTERNS = [/\b2\s?ml\b/, /\b5\s?ml\b/, /\b10\s?ml\b/, /\bechantillon\b/, /\bsample\b/, /\bdiscovery\b/];

  /** Find the sample variant from a product's variants array */
  function findSampleVariant(product) {
    if (!product.variants || product.variants.length < 2) return null;
    for (const v of product.variants) {
      const title = (v.title || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      if (SAMPLE_PATTERNS.some(p => p.test(title))) return v;
    }
    return null;
  }

  /* ============================================
     DOM REFERENCES
     ============================================ */
  const section = document.getElementById('quiz-parfum');
  if (!section) return;

  const collectionHandle = section.dataset.collection || 'all';
  const threshold = parseInt(section.dataset.threshold, 10) || 15;
  const resultsPerPage = parseInt(section.dataset.resultsCount, 10) || 12;

  const welcomeEl = document.getElementById('quizWelcome');
  const containerEl = document.getElementById('quizContainer');
  const resultsEl = document.getElementById('quizResults');
  const loadingEl = document.getElementById('quizLoading');
  const progressBar = document.getElementById('quizProgressBar');
  const resultsGrid = document.getElementById('quizResultsGrid');
  const resultsCountEl = document.getElementById('quizResultsCount');
  const loadMoreEl = document.getElementById('quizLoadMore');
  const quickResultsEl = document.getElementById('quizQuickResults');
  const diagnosticEl = document.getElementById('quizDiagnostic');
  const enableDiagnostic = section.dataset.enableDiagnostic !== 'false';

  /* ============================================
     STATE
     ============================================ */
  let questionsData = [];
  let currentStep = 0;
  let answers = {};
  let allProducts = null;
  let productsFetchPromise = null;
  let scoredProducts = [];
  let displayedCount = 0;
  let diagnosticData = null;
  let favorites = JSON.parse(sessionStorage.getItem('quiz_parfum_favs') || '[]');

  /* ============================================
     INIT
     ============================================ */
  function init() {
    // Parse questions data from JSON script tag
    const dataEl = document.getElementById('quizQuestionsData');
    if (dataEl) {
      try {
        questionsData = JSON.parse(dataEl.textContent);
      } catch (e) {
        console.error('Quiz: Failed to parse questions data', e);
        return;
      }
    }

    // Restore saved answers from sessionStorage
    const saved = sessionStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        answers = parsed.answers || {};
        currentStep = parsed.step || 0;
      } catch (e) {
        // Ignore corrupted storage
      }
    }

    // Pre-fetch products immediately
    productsFetchPromise = fetchAllProducts();

    // Render options for all questions
    renderAllOptions();

    // Bind events
    bindEvents();

    // If we have saved progress, resume quiz
    if (Object.keys(answers).length > 0) {
      showQuiz();
      goToStep(currentStep);
    }
  }

  /* ============================================
     PRODUCT FETCHER
     ============================================ */
  async function fetchAllProducts() {
    const products = [];
    let page = 1;
    let hasMore = true;

    while (hasMore) {
      try {
        const res = await fetch(
          `/collections/${collectionHandle}/products.json?limit=250&page=${page}`
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();

        if (!data.products || data.products.length === 0) {
          hasMore = false;
        } else {
          products.push(...data.products);
          if (data.products.length < 250) hasMore = false;
          page++;
        }
      } catch (err) {
        console.error('Quiz: Error fetching products', err);
        hasMore = false;
      }
    }

    allProducts = products;
    return products;
  }

  /* ============================================
     TAG NORMALIZATION
     ============================================ */
  function normalizeProductTags(tags) {
    if (typeof tags === 'string') {
      tags = tags.split(',').map(t => t.trim());
    }

    const normalized = new Set();

    for (const tag of tags) {
      const lower = tag.toLowerCase().trim();

      // Already in canonical format
      if (lower.startsWith('quiz:')) {
        normalized.add(lower);
        continue;
      }

      // Check normalization map
      if (TAG_NORMALIZE[lower]) {
        normalized.add(TAG_NORMALIZE[lower]);
        continue;
      }

      // Try stripping accents and re-checking
      const stripped = lower.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      if (TAG_NORMALIZE[stripped]) {
        normalized.add(TAG_NORMALIZE[stripped]);
        continue;
      }

      // Try prefixed formats like "famille:boise" or "famille-boise"
      const colonParts = lower.split(/[:_-]/);
      if (colonParts.length >= 2) {
        const candidate = `quiz:${colonParts[0]}:${colonParts.slice(1).join('')}`;
        normalized.add(candidate);
      }
    }

    return normalized;
  }

  /* ============================================
     SCORING ENGINE
     ============================================ */

  /** Hard-filter dimensions: mismatched value = product excluded entirely */
  const HARD_FILTER_KEYS = ['genre'];

  /** Minimum number of direct dimension matches required to appear in results */
  const MIN_MATCH_COUNT = 2;

  /** Maximum results to return (avoids overwhelming the user) */
  const MAX_RESULTS = 12;

  /** Bonus multiplier when the 3 strongest dimensions (genre + famille + notes) all match */
  const CORE_MATCH_BONUS = 1.15;

  /**
   * Penalty applied when a product has very few tagged dimensions.
   * A product tagged in only 2/8 dimensions that happens to match both
   * should not rank equally with a product tagged in 7/8 that matches 7.
   * Coverage = (tagged dimensions / answered dimensions).
   * If coverage < 50%, score is reduced proportionally.
   */
  const MIN_TAG_COVERAGE = 0.25;

  function scoreProduct(product, userAnswers) {
    const productTags = normalizeProductTags(product.tags);
    let score = 0;
    let maxScore = 0;
    let matchCount = 0;
    let taggedDimensions = 0;
    let answeredDimensions = 0;
    let coreMatches = 0;
    const coreKeys = ['genre', 'famille', 'notes'];

    for (const question of questionsData) {
      const key = question.key;
      const weight = question.weight || 5;
      const answer = userAnswers[key];

      // Skip questions the user skipped
      if (answer === undefined || answer === null) continue;

      answeredDimensions++;
      maxScore += weight;

      const answerValues = Array.isArray(answer) ? answer : [answer];
      const answerTags = answerValues.map(v => `quiz:${key}:${v}`);

      // Check if product has ANY tag for this dimension (not necessarily matching)
      const hasAnyTagForDimension = Array.from(productTags).some(t => t.startsWith(`quiz:${key}:`));
      if (hasAnyTagForDimension) taggedDimensions++;

      // Hard filter: wrong genre → exclude
      if (HARD_FILTER_KEYS.includes(key) && hasAnyTagForDimension) {
        const hasMatch = answerTags.some(tag => productTags.has(tag));
        // "mixte" products pass for any genre selection
        const isMixte = productTags.has(`quiz:${key}:mixte`);
        if (!hasMatch && !isMixte) {
          return { score: 0, relativeScore: 0, matchCount: 0, badge: '', excluded: true };
        }
        // Mixte counts as a match for scoring purposes
        if (isMixte && !hasMatch) {
          score += weight * 0.8;
          matchCount++;
          if (coreKeys.includes(key)) coreMatches++;
          continue;
        }
      }

      // Check direct match
      const hasMatch = answerTags.some(tag => productTags.has(tag));

      if (hasMatch) {
        score += weight;
        matchCount++;
        if (coreKeys.includes(key)) coreMatches++;
        continue;
      }

      // Partial credit for ordered dimensions (only if product is tagged in this dimension)
      if (ORDERED_DIMENSIONS[key] && hasAnyTagForDimension) {
        const order = ORDERED_DIMENSIONS[key];
        const userIdx = order.indexOf(answerValues[0]);

        if (userIdx >= 0) {
          const adjacent = [];
          if (userIdx > 0) adjacent.push(order[userIdx - 1]);
          if (userIdx < order.length - 1) adjacent.push(order[userIdx + 1]);

          const hasAdjacent = adjacent.some(adj =>
            productTags.has(`quiz:${key}:${adj}`)
          );

          if (hasAdjacent) {
            score += weight * ADJACENT_CREDIT;
          }
        }
      }

      // Penalty: if product IS tagged in this dimension but doesn't match at all → small penalty
      // This differentiates "product tagged soiree but user wants quotidien" from "product not tagged for occasion"
      if (hasAnyTagForDimension && !hasMatch) {
        score -= weight * 0.1;
      }
    }

    // Core match bonus: if genre + famille + notes all match, boost score
    if (coreMatches === coreKeys.filter(k => userAnswers[k] !== undefined).length && coreMatches >= 2) {
      score *= CORE_MATCH_BONUS;
    }

    // Tag coverage penalty: products with sparse tagging get reduced scores
    const coverage = answeredDimensions > 0 ? taggedDimensions / answeredDimensions : 0;
    if (coverage < MIN_TAG_COVERAGE && coverage > 0) {
      score *= (coverage / MIN_TAG_COVERAGE);
    }

    // Floor at 0
    score = Math.max(0, score);

    const relativeScore = maxScore > 0 ? Math.round((score / maxScore) * 100) : 0;

    let badge = '';
    if (relativeScore >= 75) badge = 'perfect';
    else if (relativeScore >= 55) badge = 'good';
    else if (relativeScore >= threshold) badge = 'discover';

    return { score, relativeScore, matchCount, badge, excluded: false };
  }

  function scoreAndSortProducts(userAnswers) {
    if (!allProducts) return [];

    const scored = allProducts
      .map(product => {
        const result = scoreProduct(product, userAnswers);
        return { ...product, ...result };
      })
      .filter(p =>
        !p.excluded &&
        p.relativeScore >= threshold &&
        p.matchCount >= MIN_MATCH_COUNT
      )
      .sort((a, b) => {
        // Sort by score desc, then by match count desc, then price asc
        if (b.relativeScore !== a.relativeScore) return b.relativeScore - a.relativeScore;
        if (b.matchCount !== a.matchCount) return b.matchCount - a.matchCount;
        const priceA = parseFloat(a.variants?.[0]?.price || 0);
        const priceB = parseFloat(b.variants?.[0]?.price || 0);
        return priceA - priceB;
      })
      .slice(0, MAX_RESULTS);

    return scored;
  }

  /* ============================================
     QUIZ UI
     ============================================ */
  function renderAllOptions() {
    const steps = document.querySelectorAll('.quiz__step');

    steps.forEach((stepEl, idx) => {
      if (idx >= questionsData.length) return;

      const question = questionsData[idx];
      const optionsContainer = stepEl.querySelector('.quiz__options');

      // Set question text (EN if available and locale is EN)
      const questionHeading = stepEl.querySelector('.quiz__question');
      if (questionHeading) {
        const qText = (IS_EN && question.text_en) ? question.text_en : question.text;
        questionHeading.textContent = qText;
      }

      if (question.type === 'multi') {
        optionsContainer.classList.add('quiz__options--multi');
      }

      // Use EN options if available and locale is EN
      const options = (IS_EN && question.options_en && question.options_en.length > 0)
        ? question.options_en
        : question.options;

      let html = '';
      for (const opt of options) {
        const isSelected = isAnswerSelected(question.key, opt.value);
        html += `
          <button
            type="button"
            class="quiz__option${isSelected ? ' quiz__option--selected' : ''}"
            data-value="${opt.value}"
            role="${question.type === 'single' ? 'radio' : 'checkbox'}"
            aria-checked="${isSelected}"
            aria-label="${opt.label}"
          >
            <span class="quiz__option-check">
              <svg viewBox="0 0 12 12" fill="none" aria-hidden="true">
                <path d="M2 6l3 3 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <span class="quiz__option-label">${opt.label}</span>
            ${opt.desc ? `<span class="quiz__option-desc">${opt.desc}</span>` : ''}
          </button>
        `;
      }

      optionsContainer.innerHTML = html;
    });
  }

  function isAnswerSelected(key, value) {
    const answer = answers[key];
    if (!answer) return false;
    if (Array.isArray(answer)) return answer.includes(value);
    return answer === value;
  }

  function showQuiz() {
    welcomeEl.hidden = true;
    containerEl.hidden = false;
    resultsEl.hidden = true;
    loadingEl.hidden = true;
  }

  function goToStep(idx) {
    currentStep = idx;
    const steps = document.querySelectorAll('.quiz__step');

    steps.forEach((step, i) => {
      step.hidden = i !== idx;
      if (i === idx) {
        // Re-trigger animation
        step.style.animation = 'none';
        step.offsetHeight; // force reflow
        step.style.animation = '';
      }
    });

    // Update progress bar
    const progress = ((idx + 1) / questionsData.length) * 100;
    progressBar.style.transform = 'scaleX(' + progress / 100 + ')';
    const progressContainer = progressBar.parentElement;
    progressContainer.setAttribute('aria-valuenow', Math.round(progress));

    // Show quick results after question 4
    if (quickResultsEl) {
      quickResultsEl.hidden = idx < 4;
    }

    // Update next button state
    updateNextButton(idx);

    // Save state
    saveState();

    // Focus the question heading for screen readers
    const heading = steps[idx]?.querySelector('.quiz__question');
    if (heading) heading.focus();
  }

  function updateNextButton(stepIdx) {
    const step = document.querySelectorAll('.quiz__step')[stepIdx];
    if (!step) return;

    const nextBtn = step.querySelector('.quiz__btn--next');
    if (!nextBtn) return;

    const key = questionsData[stepIdx]?.key;
    const hasAnswer = answers[key] !== undefined && answers[key] !== null;

    // Enable next if answer selected, OR if on skip
    nextBtn.disabled = !hasAnswer;
  }

  function selectOption(stepIdx, value) {
    const question = questionsData[stepIdx];
    if (!question) return;

    const key = question.key;

    if (question.type === 'multi') {
      if (!Array.isArray(answers[key])) answers[key] = [];
      const idx = answers[key].indexOf(value);
      if (idx >= 0) {
        answers[key].splice(idx, 1);
        if (answers[key].length === 0) delete answers[key];
      } else {
        answers[key].push(value);
      }
    } else {
      // Single select — toggle off if same value
      if (answers[key] === value) {
        delete answers[key];
      } else {
        answers[key] = value;
      }
    }

    // Update option visual states
    const step = document.querySelectorAll('.quiz__step')[stepIdx];
    const options = step.querySelectorAll('.quiz__option');

    options.forEach(opt => {
      const optValue = opt.dataset.value;
      const selected = isAnswerSelected(key, optValue);
      opt.classList.toggle('quiz__option--selected', selected);
      opt.setAttribute('aria-checked', selected);
    });

    updateNextButton(stepIdx);
    saveState();
  }

  function saveState() {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
      answers,
      step: currentStep,
    }));
  }

  /* ============================================
     RESULTS RENDERER
     ============================================ */
  /** Render a sample/échantillon button for a product */
  function renderSampleButton(product, context) {
    const sampleVariant = findSampleVariant(product);
    if (!sampleVariant) return '';

    const samplePrice = parseFloat(sampleVariant.price || 0);
    const sampleAvailable = sampleVariant.available !== false;
    const sampleId = sampleVariant.id;
    const cls = context === 'card' ? 'quiz-card__sample-btn' : 'quiz__modal-sample-btn';

    if (!sampleAvailable) {
      return `<button class="${cls} quiz-sample-btn" disabled>${t('sample_unavailable')}</button>`;
    }

    return `
      <button class="${cls} quiz-sample-btn" data-sample-variant="${sampleId}" data-context="${context}">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M8 1v5M5.5 4l5 0M4 7.5c0-.8.7-1.5 1.5-1.5h5c.8 0 1.5.7 1.5 1.5v6c0 .8-.7 1.5-1.5 1.5h-5C4.7 15 4 14.3 4 13.5v-6z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
        </svg>
        ${t('sample_price', { price: formatMoney(samplePrice) })}
      </button>
    `;
  }

  function renderProductCard(product) {
    const price = parseFloat(product.variants?.[0]?.price || 0);
    const comparePrice = parseFloat(product.variants?.[0]?.compare_at_price || 0);
    const image = product.images?.[0]?.src || '';
    const url = `/products/${product.handle}`;
    const variantId = product.variants?.[0]?.id || '';
    const available = product.variants?.[0]?.available !== false;

    // Extract famille from normalized tags
    let famille = '';
    const tags = normalizeProductTags(product.tags);
    for (const tag of tags) {
      if (tag.startsWith('quiz:famille:')) {
        famille = tag.replace('quiz:famille:', '');
        famille = famille.charAt(0).toUpperCase() + famille.slice(1);
        break;
      }
    }

    const badgeHTML = product.badge ? `
      <span class="quiz-card__badge quiz-card__badge--${product.badge}">
        ${product.badge === 'perfect' ? t('badge_perfect') : product.badge === 'good' ? t('badge_good') : t('badge_discover')}
      </span>
    ` : '';

    const priceHTML = comparePrice > price
      ? `<span class="quiz-card__price--sale">${formatMoney(price)}</span>
         <span class="quiz-card__price--compare">${formatMoney(comparePrice)}</span>`
      : `<span>${formatMoney(price)}</span>`;

    const isFav = favorites.some(f => f.id === product.id);
    const favSVG = `<svg width="18" height="18" viewBox="0 0 22 22" fill="none"><path d="M11 4.5C9.5 2.5 6 1.5 4 4c-2 2.5-.5 6 7 11.5C18.5 10 20 6.5 18 4c-2-2.5-5.5-1.5-7 .5z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>`;

    return `
      <article class="quiz-card" data-product-id="${product.id}" data-score="${product.relativeScore}">
        <div class="quiz-card__image-wrapper" data-quickview="${product.id}" role="button" tabindex="0" aria-label="${escapeHTML(product.title)}">
          ${image
            ? `<img class="quiz-card__image" src="${image}" alt="${escapeHTML(product.title)}" loading="lazy" width="400" height="533">`
            : `<div class="quiz-card__image-placeholder">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M24 8C15.2 8 8 15.2 8 24s7.2 16 16 16 16-7.2 16-16S32.8 8 24 8zm0 4a4 4 0 110 8 4 4 0 010-8z" fill="currentColor" opacity="0.2"/></svg>
              </div>`
          }
          ${badgeHTML}
          <button class="quiz-card__fav${isFav ? ' is-fav' : ''}" data-fav-id="${product.id}" aria-label="${t('fav_save')}">
            ${favSVG}
          </button>
        </div>
        <div class="quiz-card__info" data-quickview="${product.id}" role="button" tabindex="0">
          ${product.vendor ? `<p class="quiz-card__vendor">${escapeHTML(product.vendor)}</p>` : ''}
          <h3 class="quiz-card__title">${escapeHTML(product.title)}</h3>
          ${famille ? `<p class="quiz-card__famille">${famille}</p>` : ''}
          <div class="quiz-card__price">${priceHTML}</div>
          <div class="quiz-card__score-bar" aria-label="${t('modal_relevance')} ${product.relativeScore}%">
            <div class="quiz-card__score-fill" data-score-fill="${product.relativeScore}"></div>
          </div>
        </div>
        <div class="quiz-card__actions">
          <form method="post" action="/cart/add" class="quiz-card__form">
            <input type="hidden" name="id" value="${variantId}">
            <input type="hidden" name="quantity" value="1">
            <button type="submit" class="quiz-card__add-to-cart" ${!available ? 'disabled' : ''}>
              ${available ? t('add_to_cart') : t('sold_out')}
            </button>
          </form>
          ${renderSampleButton(product, 'card')}
        </div>
      </article>
    `;
  }

  function displayResults(products, append) {
    if (!append) {
      resultsGrid.innerHTML = '';
      displayedCount = 0;
    }

    const toShow = products.slice(displayedCount, displayedCount + resultsPerPage);
    const html = toShow.map(renderProductCard).join('');
    resultsGrid.insertAdjacentHTML('beforeend', html);
    displayedCount += toShow.length;

    // Update count
    resultsCountEl.textContent = products.length === 1
      ? t('results_count_1')
      : t('results_count', { count: products.length, plural: products.length > 1 ? 's' : '' });

    // Show/hide load more
    loadMoreEl.hidden = displayedCount >= products.length;

    // Animate score bars after a tick
    requestAnimationFrame(() => {
      resultsGrid.querySelectorAll('.quiz-card__score-fill').forEach(el => {
        el.style.transform = 'scaleX(' + (el.dataset.scoreFill || 0) / 100 + ')';
      });
    });
  }

  function applyFilters() {
    const familleFilter = document.getElementById('filterFamille')?.value || '';
    const prixFilter = document.getElementById('filterPrix')?.value || '';
    const sortFilter = document.getElementById('filterSort')?.value || 'score';

    let filtered = [...scoredProducts];

    // Filter by famille
    if (familleFilter) {
      filtered = filtered.filter(p => {
        const tags = normalizeProductTags(p.tags);
        return tags.has(`quiz:famille:${familleFilter}`);
      });
    }

    // Filter by price
    if (prixFilter) {
      filtered = filtered.filter(p => {
        const price = parseFloat(p.variants?.[0]?.price || 0);
        if (prixFilter === '0-50') return price < 50;
        if (prixFilter === '50-100') return price >= 50 && price < 100;
        if (prixFilter === '100-200') return price >= 100 && price < 200;
        if (prixFilter === '200+') return price >= 200;
        return true;
      });
    }

    // Sort
    if (sortFilter === 'price-asc') {
      filtered.sort((a, b) => parseFloat(a.variants?.[0]?.price || 0) - parseFloat(b.variants?.[0]?.price || 0));
    } else if (sortFilter === 'price-desc') {
      filtered.sort((a, b) => parseFloat(b.variants?.[0]?.price || 0) - parseFloat(a.variants?.[0]?.price || 0));
    } else if (sortFilter === 'name') {
      filtered.sort((a, b) => a.title.localeCompare(b.title, 'fr'));
    }
    // Default 'score' keeps existing sort

    displayResults(filtered, false);
  }

  /* ============================================
     DIAGNOSTIC GENERATOR
     ============================================ */

  /** Profile archetypes based on dominant answers */
  const PROFILES = [
    {
      match: { famille: 'oriental', intensite: 'intense' },
      title: { fr: 'L\'Envoûteur Oriental', en: 'The Oriental Enchanter' },
      desc: {
        fr: 'Vous êtes attiré par les fragrances profondes et mystérieuses. Les notes d\'ambre, de vanille et d\'épices vous correspondent. Votre parfum est une signature qui laisse une empreinte mémorable.',
        en: 'You are drawn to deep and mysterious fragrances. Notes of amber, vanilla and spices resonate with you. Your fragrance is a signature that leaves a lasting impression.',
      },
    },
    {
      match: { famille: 'boise', style: 'classique' },
      title: { fr: 'L\'Élégant Boisé', en: 'The Woody Connoisseur' },
      desc: {
        fr: 'Vous appréciez les parfums raffinés aux notes de cèdre, santal et vétiver. Votre style intemporel se reflète dans des fragrances sophistiquées qui inspirent confiance et respectabilité.',
        en: 'You appreciate refined fragrances with notes of cedar, sandalwood and vetiver. Your timeless style is reflected in sophisticated scents that inspire confidence and elegance.',
      },
    },
    {
      match: { famille: 'floral', style: 'romantique' },
      title: { fr: 'L\'Âme Florale', en: 'The Floral Soul' },
      desc: {
        fr: 'La délicatesse des fleurs vous parle. Rose, jasmin et iris composent votre univers olfactif. Vos parfums racontent une histoire de sensualité douce et de beauté naturelle.',
        en: 'The delicacy of flowers speaks to you. Rose, jasmine and iris compose your olfactory universe. Your fragrances tell a story of gentle sensuality and natural beauty.',
      },
    },
    {
      match: { famille: 'frais', saison: 'ete' },
      title: { fr: 'L\'Esprit Libre', en: 'The Free Spirit' },
      desc: {
        fr: 'Vous recherchez la fraîcheur et la légèreté. Agrumes pétillants et notes marines composent votre signature. Votre parfum évoque la liberté et la joie de vivre.',
        en: 'You seek freshness and lightness. Sparkling citrus and marine notes compose your signature. Your fragrance evokes freedom and joie de vivre.',
      },
    },
    {
      match: { famille: 'cuir', style: 'aventurier' },
      title: { fr: 'L\'Aventurier Audacieux', en: 'The Bold Adventurer' },
      desc: {
        fr: 'Le cuir, le tabac et les notes fumées vous fascinent. Vous aimez les parfums qui ont du caractère, qui racontent une histoire de voyages et de découvertes.',
        en: 'Leather, tobacco and smoky notes fascinate you. You love fragrances with character that tell a story of travel and discovery.',
      },
    },
    {
      match: { famille: 'epice', intensite: 'intense' },
      title: { fr: 'Le Voyageur Épicé', en: 'The Spice Voyager' },
      desc: {
        fr: 'Cannelle, poivre et cardamome composent votre palette olfactive. Vos parfums sont chaleureux et enveloppants, évoquant des destinations lointaines et exotiques.',
        en: 'Cinnamon, pepper and cardamom compose your olfactory palette. Your fragrances are warm and enveloping, evoking distant and exotic destinations.',
      },
    },
    {
      match: { famille: 'oriental' },
      title: { fr: 'Le Mystérieux Oriental', en: 'The Mysterious Oriental' },
      desc: {
        fr: 'L\'Orient vous attire avec ses fragrances enveloppantes. Ambre, vanille et bois précieux composent votre univers. Chaque parfum est pour vous une invitation au voyage intérieur.',
        en: 'The Orient attracts you with its enveloping fragrances. Amber, vanilla and precious woods compose your universe. Each fragrance is an invitation to an inner journey.',
      },
    },
    {
      match: { famille: 'boise' },
      title: { fr: 'Le Raffiné Boisé', en: 'The Refined Woodsman' },
      desc: {
        fr: 'Les bois nobles sont votre terrain de prédilection. Cèdre, santal et vétiver forment la base de vos parfums préférés. Vous recherchez l\'élégance naturelle et la profondeur.',
        en: 'Noble woods are your playground. Cedar, sandalwood and vetiver form the base of your favourite fragrances. You seek natural elegance and depth.',
      },
    },
    {
      match: { famille: 'floral' },
      title: { fr: 'Le Poète Floral', en: 'The Floral Poet' },
      desc: {
        fr: 'Les fleurs nobles composent votre jardin olfactif. Chaque parfum est un bouquet soigneusement composé qui reflète votre sensibilité artistique.',
        en: 'Noble flowers compose your olfactory garden. Each fragrance is a carefully composed bouquet that reflects your artistic sensibility.',
      },
    },
  ];

  function generateDiagnostic(userAnswers) {
    // Find best matching profile
    let bestProfile = PROFILES[PROFILES.length - 1]; // fallback
    let bestMatchCount = 0;

    for (const profile of PROFILES) {
      let matchCount = 0;
      let totalCriteria = Object.keys(profile.match).length;

      for (const [key, val] of Object.entries(profile.match)) {
        if (userAnswers[key] === val) matchCount++;
      }

      if (matchCount === totalCriteria && totalCriteria > bestMatchCount) {
        bestProfile = profile;
        bestMatchCount = totalCriteria;
      }
    }

    // Build summary cards data
    const summaryCards = [];
    for (const [key, val] of Object.entries(userAnswers)) {
      if (val === undefined || val === null) continue;
      const displayVal = Array.isArray(val)
        ? val.map(v => tVal(v)).join(', ')
        : tVal(val);
      summaryCards.push({
        label: tDim(key),
        value: displayVal,
      });
    }

    return {
      title: bestProfile.title[LOCALE] || bestProfile.title.fr,
      desc: bestProfile.desc[LOCALE] || bestProfile.desc.fr,
      cards: summaryCards,
    };
  }

  function renderDiagnostic(data) {
    diagnosticData = data;

    const titleEl = document.getElementById('diagnosticTitle');
    const descEl = document.getElementById('diagnosticDesc');
    const summaryEl = document.getElementById('diagnosticSummary');

    if (titleEl) titleEl.textContent = data.title;
    if (descEl) descEl.textContent = data.desc;

    if (summaryEl) {
      summaryEl.innerHTML = data.cards.map(card => `
        <div class="quiz__diagnostic-card">
          <div class="quiz__diagnostic-card-label">${escapeHTML(card.label)}</div>
          <div class="quiz__diagnostic-card-value">${escapeHTML(card.value)}</div>
        </div>
      `).join('');
    }
  }

  /** Build diagnostic email body as HTML */
  function buildDiagnosticEmailBody(prenom) {
    const name = prenom ? escapeHTML(prenom) : t('email_greeting');
    const topProducts = scoredProducts.slice(0, 3);

    let productsHTML = '';
    if (topProducts.length > 0) {
      productsHTML = `
        <h3 style="color:#C8A97E;font-size:16px;margin:24px 0 12px;">${t('email_top3')}</h3>
        ${topProducts.map((p, i) => `
          <div style="margin-bottom:12px;padding:12px;background:#242424;border-radius:8px;">
            <strong style="color:#f5f0eb;">${i + 1}. ${escapeHTML(p.title)}</strong>
            ${p.vendor ? `<span style="color:#C8A97E;font-size:13px;"> · ${escapeHTML(p.vendor)}</span>` : ''}
            <br><span style="color:#8a8279;font-size:13px;">${t('email_relevance')} : ${p.relativeScore}%</span>
          </div>
        `).join('')}
      `;
    }

    const cardsHTML = diagnosticData.cards.map(c =>
      `<strong style="color:#C8A97E;">${escapeHTML(c.label)}</strong>: ${escapeHTML(c.value)}`
    ).join(' · ');

    return `
      <div style="background:#1a1a1a;color:#f5f0eb;padding:32px;font-family:Arial,sans-serif;max-width:600px;margin:0 auto;border-radius:12px;">
        <h1 style="color:#C8A97E;font-size:24px;font-weight:normal;text-align:center;margin-bottom:4px;">${t('email_title')}</h1>
        <p style="text-align:center;color:#8a8279;font-size:14px;">${t('email_brand')}</p>
        <hr style="border:none;border-top:1px solid #3a3530;margin:24px 0;">
        <p>${name},</p>
        <h2 style="color:#f5f0eb;font-size:20px;margin:16px 0 8px;">${escapeHTML(diagnosticData.title)}</h2>
        <p style="color:#8a8279;line-height:1.6;">${escapeHTML(diagnosticData.desc)}</p>
        <div style="margin:20px 0;padding:16px;background:#242424;border-radius:8px;font-size:14px;line-height:2;">
          ${cardsHTML}
        </div>
        ${productsHTML}
        <div style="text-align:center;margin:32px 0 16px;">
          <a href="${window.location.origin}/pages/trouvez-votre-parfum" style="display:inline-block;background:#C8A97E;color:#1a1a1a;padding:12px 32px;border-radius:8px;text-decoration:none;font-weight:bold;">${t('email_cta')}</a>
        </div>
        <p style="color:#8a8279;font-size:12px;text-align:center;margin-top:32px;">
          ${t('email_footer')}
        </p>
      </div>
    `;
  }

  /** Send diagnostic via Shopify contact form + newsletter subscription */
  async function sendDiagnostic(email, prenom, subscribeNewsletter) {
    const results = [];

    // 1. Send diagnostic email via Shopify contact form
    const emailBody = buildDiagnosticEmailBody(prenom);
    const contactFormData = new FormData();
    contactFormData.append('form_type', 'contact');
    contactFormData.append('utf8', '✓');
    contactFormData.append('contact[email]', email);
    contactFormData.append('contact[name]', prenom || '');
    contactFormData.append('contact[subject]', 'Diagnostic Olfactif : ' + (diagnosticData?.title || 'Quiz Parfum'));
    contactFormData.append('contact[body]', [
      'DIAGNOSTIC OLFACTIF',
      '==================',
      '',
      `Profil: ${diagnosticData?.title || ''}`,
      `Description: ${diagnosticData?.desc || ''}`,
      '',
      'Réponses:',
      ...(diagnosticData?.cards || []).map(c => `  ${c.label}: ${c.value}`),
      '',
      `Top recommandations: ${scoredProducts.slice(0, 5).map(p => p.title).join(', ')}`,
      '',
      `Nombre total de résultats: ${scoredProducts.length}`,
      `Newsletter: ${subscribeNewsletter ? 'Oui' : 'Non'}`,
    ].join('\n'));

    try {
      await fetch('/contact#contact_form', {
        method: 'POST',
        body: contactFormData,
      });
      results.push('contact_sent');
    } catch (e) {
      console.error('Quiz: contact form error', e);
    }

    // 2. Subscribe to newsletter via Shopify customer form
    if (subscribeNewsletter) {
      const newsletterData = new FormData();
      newsletterData.append('form_type', 'customer');
      newsletterData.append('utf8', '✓');
      newsletterData.append('customer[email]', email);
      newsletterData.append('customer[first_name]', prenom || '');
      newsletterData.append('customer[tags]', 'quiz-parfum,newsletter');

      try {
        await fetch('/contact#newsletter', {
          method: 'POST',
          body: newsletterData,
        });
        results.push('newsletter_subscribed');
      } catch (e) {
        console.error('Quiz: newsletter error', e);
      }
    }

    return results;
  }

  /* ============================================
     SHOW RESULTS (with diagnostic step)
     ============================================ */
  async function showResults() {
    containerEl.hidden = true;
    loadingEl.hidden = false;
    resultsEl.hidden = true;
    if (diagnosticEl) diagnosticEl.hidden = true;

    // Wait for products if not yet loaded
    if (!allProducts) {
      await productsFetchPromise;
    }

    // Score products
    scoredProducts = scoreAndSortProducts(answers);

    // Small delay for perceived effort
    await new Promise(r => setTimeout(r, 800));

    loadingEl.hidden = true;

    // Track quiz completion
    trackEvent('quiz_complete', {
      answers_count: Object.keys(answers).length,
      results_count: scoredProducts.length,
    });

    // Show diagnostic screen if enabled, otherwise go straight to results
    if (enableDiagnostic && diagnosticEl) {
      const diag = generateDiagnostic(answers);
      renderDiagnostic(diag);
      diagnosticEl.hidden = false;
      diagnosticEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      showProductResults();
    }
  }

  function showProductResults() {
    if (diagnosticEl) diagnosticEl.hidden = true;
    resultsEl.hidden = false;
    displayResults(scoredProducts, false);
    renderFavBar();
    resultsEl.scrollIntoView({ behavior: 'smooth' });
  }

  /* ============================================
     EVENTS
     ============================================ */
  function bindEvents() {
    // Start quiz
    document.getElementById('quizStart')?.addEventListener('click', () => {
      showQuiz();
      goToStep(0);
      trackEvent('quiz_start');
    });

    // Option selection (delegated)
    containerEl?.addEventListener('click', e => {
      const option = e.target.closest('.quiz__option');
      if (option) {
        selectOption(currentStep, option.dataset.value);
      }
    });

    // Navigation (delegated)
    containerEl?.addEventListener('click', e => {
      const btn = e.target.closest('[data-direction]');
      if (!btn) return;

      const direction = btn.dataset.direction;

      if (direction === 'next') {
        if (currentStep < questionsData.length - 1) {
          goToStep(currentStep + 1);
          trackEvent('quiz_step', { step: currentStep });
        }
      } else if (direction === 'prev') {
        if (currentStep > 0) {
          goToStep(currentStep - 1);
        }
      } else if (direction === 'skip') {
        // Remove answer for current question
        const key = questionsData[currentStep]?.key;
        if (key) delete answers[key];
        saveState();

        if (currentStep < questionsData.length - 1) {
          goToStep(currentStep + 1);
        } else {
          showResults();
        }
      } else if (direction === 'results') {
        showResults();
      }
    });

    // Quick results
    document.getElementById('quizQuickResultsBtn')?.addEventListener('click', () => {
      showResults();
    });

    // Keyboard navigation for options
    containerEl?.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        const option = e.target.closest('.quiz__option');
        if (option) {
          e.preventDefault();
          selectOption(currentStep, option.dataset.value);
        }
      }
    });

    // Filters
    document.getElementById('filterFamille')?.addEventListener('change', applyFilters);
    document.getElementById('filterPrix')?.addEventListener('change', applyFilters);
    document.getElementById('filterSort')?.addEventListener('change', applyFilters);

    // Load more
    document.getElementById('quizLoadMoreBtn')?.addEventListener('click', () => {
      displayResults(scoredProducts, true);
    });

    // Restart
    document.getElementById('quizRestart')?.addEventListener('click', () => {
      answers = {};
      currentStep = 0;
      sessionStorage.removeItem(STORAGE_KEY);
      renderAllOptions();
      showQuiz();
      goToStep(0);
    });

    // Add to cart (delegated from results grid)
    resultsGrid?.addEventListener('submit', e => {
      const form = e.target.closest('.quiz-card__form');
      if (!form) return;

      e.preventDefault();
      const formData = new FormData(form);
      const btn = form.querySelector('.quiz-card__add-to-cart');
      const originalText = btn.textContent;

      btn.disabled = true;
      btn.textContent = t('adding');

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then(res => {
          if (!res.ok) throw new Error('Cart error');
          return res.json();
        })
        .then(() => {
          btn.textContent = t('added');
          btn.style.background = 'var(--quiz-accent)';
          btn.style.borderColor = 'var(--quiz-accent)';
          btn.style.color = '#1a1a1a';

          // Update cart counter if theme supports it
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              const counters = document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count');
              counters.forEach(el => {
                el.textContent = cart.item_count;
              });
            });

          trackEvent('quiz_add_to_cart', {
            product_id: formData.get('id'),
          });

          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
            btn.style.background = '';
            btn.style.borderColor = '';
            btn.style.color = '';
          }, 2000);
        })
        .catch(() => {
          btn.textContent = t('error');
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        });
    });

    // --- Diagnostic events ---

    // Send diagnostic form
    document.getElementById('diagnosticForm')?.addEventListener('submit', async e => {
      e.preventDefault();

      const emailInput = document.getElementById('diagnosticEmail');
      const prenomInput = document.getElementById('diagnosticPrenom');
      const newsletterCheckbox = document.getElementById('diagnosticNewsletter');
      const sendBtn = document.getElementById('diagnosticSendBtn');
      const form = document.getElementById('diagnosticForm');
      const confirmation = document.getElementById('diagnosticConfirmation');
      const ctaEl = document.getElementById('diagnosticCta');

      const email = emailInput?.value?.trim();
      if (!email) return;

      const prenom = prenomInput?.value?.trim() || '';
      const subscribeNewsletter = newsletterCheckbox?.checked || false;

      // Disable form
      sendBtn.disabled = true;
      sendBtn.textContent = t('btn_sending');

      try {
        await sendDiagnostic(email, prenom, subscribeNewsletter);

        trackEvent('quiz_diagnostic_sent', {
          newsletter: subscribeNewsletter,
          has_prenom: !!prenom,
        });

        // Show confirmation
        form.hidden = true;
        confirmation.hidden = false;
        if (ctaEl) ctaEl.hidden = false;
      } catch (err) {
        console.error('Quiz: send diagnostic error', err);
        sendBtn.textContent = t('btn_send_retry');
        sendBtn.disabled = false;
      }
    });

    // Skip diagnostic email
    document.getElementById('diagnosticSkipBtn')?.addEventListener('click', () => {
      trackEvent('quiz_diagnostic_skipped');
      showProductResults();
    });

    // Show results from diagnostic CTA
    document.getElementById('diagnosticShowResults')?.addEventListener('click', () => {
      showProductResults();
    });

    // --- Quick-view modal ---

    // Open modal on card click (but not on fav button or cart form)
    resultsGrid?.addEventListener('click', e => {
      const qvTrigger = e.target.closest('[data-quickview]');
      if (!qvTrigger) return;
      // Don't open if clicking the fav button
      if (e.target.closest('.quiz-card__fav')) return;
      e.preventDefault();
      const productId = parseInt(qvTrigger.dataset.quickview);
      const product = scoredProducts.find(p => p.id === productId);
      if (product) openModal(product);
    });

    // Close modal
    document.getElementById('quizModalClose')?.addEventListener('click', closeModal);
    document.getElementById('quizModalOverlay')?.addEventListener('click', e => {
      if (e.target === e.currentTarget) closeModal();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeModal();
    });

    // Modal cart form
    document.getElementById('modalCartForm')?.addEventListener('submit', e => {
      e.preventDefault();
      const btn = document.getElementById('modalCartBtn');
      const form = e.target;
      const formData = new FormData(form);
      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = t('adding');

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => { if (!r.ok) throw new Error(); return r.json(); })
        .then(() => {
          btn.textContent = t('added');
          setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2000);
          fetch('/cart.js').then(r => r.json()).then(cart => {
            document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count')
              .forEach(el => { el.textContent = cart.item_count; });
          });
        })
        .catch(() => {
          btn.textContent = t('error');
          setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2000);
        });
    });

    // Modal fav button
    document.getElementById('modalFavBtn')?.addEventListener('click', () => {
      const productId = parseInt(document.getElementById('modalFavBtn').dataset.productId);
      const product = scoredProducts.find(p => p.id === productId);
      if (product) toggleFavorite(product);
      updateModalFavState(productId);
    });

    // --- Favorites from card ---
    resultsGrid?.addEventListener('click', e => {
      const favBtn = e.target.closest('.quiz-card__fav');
      if (!favBtn) return;
      e.preventDefault();
      e.stopPropagation();
      const productId = parseInt(favBtn.dataset.favId);
      const product = scoredProducts.find(p => p.id === productId);
      if (product) {
        toggleFavorite(product);
        favBtn.classList.toggle('is-fav', favorites.some(f => f.id === productId));
      }
    });

    // Favorites bar: click chip opens modal
    document.getElementById('favList')?.addEventListener('click', e => {
      const chip = e.target.closest('.quiz__fav-chip');
      const removeBtn = e.target.closest('.quiz__fav-chip-remove');
      if (removeBtn) {
        e.stopPropagation();
        const id = parseInt(removeBtn.dataset.favId);
        removeFavorite(id);
        return;
      }
      if (chip) {
        const id = parseInt(chip.dataset.favId);
        const product = scoredProducts.find(p => p.id === id);
        if (product) openModal(product);
      }
    });

    // Clear all favorites
    document.getElementById('favClearBtn')?.addEventListener('click', () => {
      favorites = [];
      saveFavorites();
      renderFavBar();
      resultsGrid?.querySelectorAll('.quiz-card__fav').forEach(b => b.classList.remove('is-fav'));
    });

    // --- Sample buttons (delegated on entire section) ---
    section.addEventListener('click', e => {
      const sampleBtn = e.target.closest('.quiz-sample-btn');
      if (!sampleBtn || sampleBtn.disabled) return;
      e.preventDefault();

      const variantId = sampleBtn.dataset.sampleVariant;
      if (!variantId) return;

      const originalHTML = sampleBtn.innerHTML;
      sampleBtn.disabled = true;
      sampleBtn.textContent = t('sample_adding');

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => { if (!r.ok) throw new Error(); return r.json(); })
        .then(() => {
          sampleBtn.textContent = t('sample_added');
          sampleBtn.style.borderColor = 'var(--quiz-accent)';
          sampleBtn.style.color = 'var(--quiz-accent)';
          // Update cart count
          fetch('/cart.js').then(r => r.json()).then(cart => {
            document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count')
              .forEach(el => { el.textContent = cart.item_count; });
          });
          trackEvent('quiz_add_sample', { variant_id: variantId });
          setTimeout(() => {
            sampleBtn.innerHTML = originalHTML;
            sampleBtn.disabled = false;
            sampleBtn.style.borderColor = '';
            sampleBtn.style.color = '';
          }, 2000);
        })
        .catch(() => {
          sampleBtn.textContent = t('error');
          setTimeout(() => {
            sampleBtn.innerHTML = originalHTML;
            sampleBtn.disabled = false;
          }, 2000);
        });
    });
  }

  /* ============================================
     QUICK-VIEW MODAL
     ============================================ */
  function openModal(product) {
    const overlay = document.getElementById('quizModalOverlay');
    if (!overlay) return;

    const image = product.images?.[0]?.src || '';
    const price = parseFloat(product.variants?.[0]?.price || 0);
    const comparePrice = parseFloat(product.variants?.[0]?.compare_at_price || 0);
    const variantId = product.variants?.[0]?.id || '';
    const available = product.variants?.[0]?.available !== false;
    const url = `/products/${product.handle}`;

    // Populate
    const imgEl = document.getElementById('modalImage');
    if (imgEl) { imgEl.src = image; imgEl.alt = product.title; }
    document.getElementById('modalVendor').textContent = product.vendor || '';
    document.getElementById('modalTitle').textContent = product.title;
    document.getElementById('modalDetailLink').href = url;
    document.getElementById('modalVariantId').value = variantId;

    // Badge
    const badgeEl = document.getElementById('modalBadge');
    if (product.badge) {
      badgeEl.textContent = product.badge === 'perfect' ? t('badge_perfect') : product.badge === 'good' ? t('badge_good') : t('badge_discover');
      badgeEl.dataset.badge = product.badge;
      badgeEl.hidden = false;
    } else {
      badgeEl.hidden = true;
    }

    // Famille
    let famille = '';
    const tags = normalizeProductTags(product.tags);
    for (const tag of tags) {
      if (tag.startsWith('quiz:famille:')) {
        const raw = tag.replace('quiz:famille:', '');
        famille = tVal(raw);
        break;
      }
    }
    document.getElementById('modalFamille').textContent = famille;

    // Tags pills (notes, occasion, saison, etc.)
    const tagsContainer = document.getElementById('modalTags');
    const displayTags = [];
    for (const tag of tags) {
      if (tag.startsWith('quiz:notes:') || tag.startsWith('quiz:occasion:') || tag.startsWith('quiz:saison:') || tag.startsWith('quiz:intensite:')) {
        const val = tag.split(':')[2];
        displayTags.push(tVal(val));
      }
    }
    tagsContainer.innerHTML = displayTags.map(t => `<span class="quiz__modal-tag">${escapeHTML(t)}</span>`).join('');

    // Price
    const priceEl = document.getElementById('modalPrice');
    priceEl.innerHTML = comparePrice > price
      ? `<span class="quiz-card__price--sale">${formatMoney(price)}</span><span class="quiz-card__price--compare">${formatMoney(comparePrice)}</span>`
      : `<span>${formatMoney(price)}</span>`;

    // Score bar
    document.getElementById('modalScoreFill').style.transform = 'scaleX(' + product.relativeScore / 100 + ')';
    document.getElementById('modalScoreValue').textContent = product.relativeScore + '%';

    // Cart button state
    const cartBtn = document.getElementById('modalCartBtn');
    cartBtn.disabled = !available;
    cartBtn.querySelector('span').textContent = available ? t('add_to_cart') : t('sold_out');

    // Sample button in modal
    const modalSampleContainer = document.getElementById('modalSampleContainer');
    if (modalSampleContainer) {
      modalSampleContainer.innerHTML = renderSampleButton(product, 'modal');
    }

    // Fav state
    const favBtn = document.getElementById('modalFavBtn');
    favBtn.dataset.productId = product.id;
    updateModalFavState(product.id);

    // Show
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';

    trackEvent('quiz_quickview', { product_id: product.id, title: product.title });
  }

  function closeModal() {
    const overlay = document.getElementById('quizModalOverlay');
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
  }

  function updateModalFavState(productId) {
    const favBtn = document.getElementById('modalFavBtn');
    const isFav = favorites.some(f => f.id === productId);
    favBtn?.classList.toggle('is-fav', isFav);
  }

  /* ============================================
     FAVORITES SYSTEM
     ============================================ */
  function toggleFavorite(product) {
    const idx = favorites.findIndex(f => f.id === product.id);
    if (idx >= 0) {
      favorites.splice(idx, 1);
    } else {
      favorites.push({
        id: product.id,
        title: product.title,
        image: product.images?.[0]?.src || '',
        handle: product.handle,
        score: product.relativeScore,
      });
    }
    saveFavorites();
    renderFavBar();
    trackEvent('quiz_favorite_toggle', { product_id: product.id, action: idx >= 0 ? 'remove' : 'add' });
  }

  function removeFavorite(productId) {
    favorites = favorites.filter(f => f.id !== productId);
    saveFavorites();
    renderFavBar();
    // Update card and modal
    resultsGrid?.querySelector(`.quiz-card__fav[data-fav-id="${productId}"]`)?.classList.remove('is-fav');
    if (parseInt(document.getElementById('modalFavBtn')?.dataset.productId) === productId) {
      updateModalFavState(productId);
    }
  }

  function saveFavorites() {
    sessionStorage.setItem('quiz_parfum_favs', JSON.stringify(favorites));
  }

  function renderFavBar() {
    const bar = document.getElementById('quizFavBar');
    const list = document.getElementById('favList');
    const count = document.getElementById('favCount');
    if (!bar || !list) return;

    if (favorites.length === 0) {
      bar.hidden = true;
      document.body.classList.remove('quiz-has-favs');
      return;
    }

    bar.hidden = false;
    document.body.classList.add('quiz-has-favs');
    count.textContent = favorites.length;

    list.innerHTML = favorites.map(f => `
      <div class="quiz__fav-chip" data-fav-id="${f.id}" role="button" tabindex="0" aria-label="${escapeHTML(f.title)}">
        ${f.image ? `<img class="quiz__fav-chip-img" src="${f.image}" alt="" loading="lazy">` : ''}
        <span class="quiz__fav-chip-name">${escapeHTML(f.title)}</span>
        <button class="quiz__fav-chip-remove" data-fav-id="${f.id}" aria-label="Remove">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M9 3L3 9M3 3l6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
        </button>
      </div>
    `).join('');
  }

  /* ============================================
     UTILITIES
     ============================================ */
  function formatMoney(cents) {
    // Shopify returns price in the store's currency unit
    const amount = typeof cents === 'string' ? parseFloat(cents) : cents;
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
    }).format(amount);
  }

  function escapeHTML(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function trackEvent(name, data) {
    // Shopify analytics
    if (window.ShopifyAnalytics?.lib?.track) {
      window.ShopifyAnalytics.lib.track(name, data);
    }
    // Google Analytics / GTM
    if (window.dataLayer) {
      window.dataLayer.push({ event: name, ...data });
    }
    // Console in dev
    if (window.location.hostname === 'localhost' || window.Shopify?.designMode) {
      console.log(`[Quiz] ${name}`, data);
    }
  }

  /* ============================================
     BOOT
     ============================================ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
